import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Search as SearchIcon } from 'lucide-react'
import SearchInput from '@/components/SearchInput'
import ImageCard from '@/components/ImageCard'
import Loading from '@/components/Loading'
import EmptyState from '@/components/EmptyState'
import { useFilteredImages } from '@/hooks/useImages'

export default function Search() {
  const [searchParams, setSearchParams] = useSearchParams()
  const initialQuery = searchParams.get('q') || ''
  const [query, setQuery] = useState(initialQuery)

  const { images, isLoading } = useFilteredImages('all', query)

  useEffect(() => {
    const params = new URLSearchParams()
    if (query) {
      params.set('q', query)
    }
    setSearchParams(params, { replace: true })
  }, [query, setSearchParams])

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="max-w-2xl mx-auto mb-12">
        <div className="text-center mb-8">
          <SearchIcon className="h-12 w-12 text-primary-500 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-white mb-2">Search Images</h1>
          <p className="text-dark-400">
            Find the perfect container image for your project
          </p>
        </div>

        <SearchInput
          value={query}
          onChange={setQuery}
          placeholder="Search by name (e.g., node, python, nginx)..."
          autoFocus
        />
      </div>

      {!query ? (
        <div className="text-center py-12">
          <p className="text-dark-400">
            Start typing to search for images
          </p>
        </div>
      ) : isLoading ? (
        <Loading text="Searching..." />
      ) : images.length === 0 ? (
        <EmptyState
          title="No results found"
          description={`No images match "${query}". Try a different search term.`}
          action={{
            label: 'Browse all images',
            href: '/images',
          }}
        />
      ) : (
        <div>
          <p className="text-dark-400 mb-6">
            {images.length} result{images.length !== 1 ? 's' : ''} for "{query}"
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {images.map(image => (
              <ImageCard key={image.name} image={image} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
